// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed826f10","455":"bbeee79c","977":"c38fb057"}[chunkId] + ".chunk.js";
};